import React from 'react'
import _ from 'lodash'

// import { View } from 'react-native'
import { Map } from 'immutable'
import { StackNavigationProp } from '@react-navigation/stack'

import { COLORS } from 'x/config/styles'
import { IBundleProductMapping, IMap, IProductDetailVariant, IProductVariantType } from 'x/types'
import * as NavActions from 'x/utils/navigation'
import p from 'x/config/platform-specific'
import assets from 'xui/assets'

import VStack from './VStack'
import HStack from './HStack'
import XText from './XText'
import XImage from './XImage'
// import Box from './Box'
// import XButton from './XButton'

interface IProductBundleItem {
  product_bundle_id?: number
  bundled_pp_count?: number
  bundled_pp_qty?: number

  bundle_product_mappings?: IBundleProductMapping[]
  assembly_product_mappings?: IBundleProductMapping[]

  [key: string]: any
}
interface IProductBundleContainerProps {
  navigation?: StackNavigationProp<any>
  storeId?: number

  // productVariant: IProductDetailVariant | IMap<IProductDetailVariant>
  productBundleItem: IProductBundleItem | IMap<IProductBundleItem>

  children: React.ReactNode

  renderRightHeader?: (type: IProductVariantType) => React.ReactNode
  hideBorder?: boolean
}

const ProductBundleContainer = (props: IProductBundleContainerProps) => {
  const { productBundleItem, children, renderRightHeader, navigation, storeId, hideBorder = false } = props
  const [type, setType] = React.useState<IProductVariantType>('standard_product')
  const pv: IProductBundleItem = Map.isMap(productBundleItem) ? productBundleItem.toJS() : productBundleItem
  const ppIds = pv && _.isArray(pv.bundle_product_mappings) ? pv.bundle_product_mappings.map((mapping: any) => mapping.pp_id) : []
  const navigationDisabled = !navigation || !storeId

  React.useEffect(() => {
    if ((pv && 'product_bundle_id' in pv) || 'product_bundle_qty_mappings' in pv || 'bundle_product_mappings' in pv) {
      setType('bundle')
    } else if ((pv && 'product_assembly_id' in pv) || 'product_assembly_qty_mappings' in pv || 'assembly_product_mappings' in pv) {
      setType('assembly')
    } else {
      setType('standard_product')
    }
  }, [productBundleItem])

  // const _navToSearchProductVariantListView = () => {
  //   // console.log('_navToSearchProductVariantListView pv => ', pv)
  //   // console.log('_navToSearchProductVariantListView ppIds => ', ppIds)
  //   if (!ppIds || ppIds.length === 0) {
  //     p.op.alert('ข้อมูลยังไม่ครบถ้วน', 'จะกระโดดไป รายการสต๊อก แต่ไม่พบ bundle_product_mappings จึงไม่มี pp_ids สำหรับใช้กรองสินค้า')
  //     return
  //   }

  //   navigation.dispatch(
  //     NavActions.navToSearchProductVariantListView({
  //       store_id: storeId,
  //       pp_ids: ppIds,
  //     })
  //   )
  // }

  const _navToProductToBundleDetail = () => {
    if (!pv.product_bundle_id) {
      return
    }
    navigation.dispatch(
      NavActions.navToProductBundleMapper({
        mode: 'detail',
        type: 'bundle',
        store_id: storeId,
        product_bundle_id: pv.product_bundle_id,
      })
    )
  }

  let textColor = COLORS.PRODUCT_STANDARD_TEXT
  if (type === 'bundle') {
    textColor = COLORS.PRODUCT_BUNDLE_TEXT
  } else if (type === 'assembly') {
    textColor = COLORS.PRODUCT_ASSEMBLY_TEXT
  }

  let bgColor = COLORS.PRODUCT_STANDARD_BG
  if (type === 'bundle') {
    bgColor = COLORS.PRODUCT_BUNDLE_BG
  } else if (type === 'assembly') {
    bgColor = COLORS.PRODUCT_ASSEMBLY_BG
  }

  let label = 'สินค้าเดี่ยว'
  if (type === 'bundle') {
    label = 'สินค้าเซต'
  } else if (type === 'assembly') {
    label = 'สินค้าประกอบ'
  }

  const bundled_pp_count = Map.isMap(productBundleItem) ? productBundleItem.get('bundled_pp_count') : productBundleItem.bundled_pp_count
  const bundled_sum_qty = Map.isMap(productBundleItem) ? productBundleItem.get('bundled_sum_qty') : productBundleItem.bundled_sum_qty

  const isHideBorder = hideBorder || type === 'standard_product'
  const isStandardProduct = type === 'standard_product'

  return (
    <VStack w='full' borderWidth={isHideBorder ? '0' : '1'} borderColor={textColor} borderRadius='lg' overflow='hidden'>
      {!isStandardProduct ? (
        <HStack w='full' px='1' py='0.5' alignItems='center' bg={bgColor} space='1'>
          <HStack w='150px' px='1' py='0.5' alignItems='center' space='1'>
            {/* <Box w='28px' h='28px' bg={textColor} borderRadius='full' p='1' /> */}
            {type === 'bundle' && <XImage width='24px' height='24px' source={assets.images.product.bundleProduct} />}
            {type === 'assembly' && <XImage width='24px' height='24px' source={assets.images.product.assemblyProduct} />}

            <XText color={textColor} bold>
              {label}
            </XText>
          </HStack>

          <HStack flex={1} alignItems='center' justifyContent='flex-end' space='1.5'>
            {/* <XButton onPress={() => p.op.alert('Check PV', JSON.stringify(pv))} variant='outline' colorScheme={colorScheme} size='xs'>
            Check PV
          </XButton> */}
            {_.isFunction(renderRightHeader) ? renderRightHeader(type) : null}

            {/* {!_.isFunction(renderRightHeader) && !navigationDisabled && type === 'bundle' && bundled_pp_count && bundled_pp_count > 0 && (
              <XText color='blue.500' underline onPress={_navToSearchProductVariantListView}>{`สินค้า: ${bundled_pp_count}`}</XText>
            )} */}

            {!_.isFunction(renderRightHeader) &&
              !navigationDisabled &&
              type === 'bundle' &&
              bundled_pp_count &&
              bundled_pp_count > 0 &&
              bundled_sum_qty &&
              bundled_sum_qty > 0 && (
                <XText color='blue.500' underline onPress={_navToProductToBundleDetail}>
                  {`สินค้า: ${bundled_pp_count}, จำนวน: ${bundled_sum_qty}`}
                </XText>
              )}

            {/* {!_.isFunction(renderRightHeader) && type === 'bundle' && bundled_pp_count && bundled_pp_count > 0 && (
              <XText color='blue.500' underline>
                {'อยู่ใน 4 สินค้าประกอบ'}
              </XText>
          )} */}
          </HStack>
        </HStack>
      ) : null}

      <VStack w='full' p='0.5'>
        {children}
      </VStack>
    </VStack>
  )
}

export default ProductBundleContainer
